"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
var _utils = require("../utils");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MessageSystem = function MessageSystem(props) {
  var message = props.message;
  var formattedMessage = message;

  // message text contains user.id not user.name so override it
  if ((0, _utils.isBanningMessage)(message.command)) {
    var argsParts = message.args.split(' ').map(_lodash.trim);
    var _argsParts = _toArray(argsParts),
      bannedUserName = _argsParts[0],
      banReasonParts = _argsParts.slice(1);
    var banReason = banReasonParts.join(' ');
    formattedMessage = (0, _lodash.cloneDeep)((0, _lodash.assign)(message, {
      text: message.command === _utils.CHAT_COMMANDS.BAN ? "user ".concat(bannedUserName, " banned with reason ").concat(banReason) : "user ".concat(bannedUserName, " unbanned")
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_streamChatReact.EventComponent, _extends({}, props, {
    message: formattedMessage
  }));
};
var _default = MessageSystem;
exports.default = _default;